// @ts-strict-ignore
import { Colors } from "themes/color-palette";
import styled from "styled-components";

export const PromoRibbon = styled.div`
  padding: 16px;
  text-align: center;
  width: 100%;
  background-color: ${Colors.cyan};
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex-wrap: wrap;

  ${({ isMobile }) =>
    isMobile &&
    `
  display: block;

  `}
`;
